module.exports = __webpack_public_path__ + "static/img/kjhf_add_new.3d1aedb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf_add_new.jpeg
// module id = 1236
// module chunks = 0